import {createContext} from 'react'
import {AuthorizationModel} from './Authorization.model';
import {ConfigurationModel} from './Configuration.model';
import {LanguageModel} from './Language.model';
import {LanguageFileModel} from "./LanguageFile.model";
import {UsersModel} from "@app/models/Users.model";
import {LangFilesAcceptedModel} from './LangFilesAccepted.model';

export const modelStoreContext = createContext({
    authorizationModel: new AuthorizationModel,
    languageModel: new LanguageModel,
    configurationModel: new ConfigurationModel,
    languageFileModel: new LanguageFileModel,
    langFilesAcceptedModel: new LangFilesAcceptedModel,
    usersModel: new UsersModel,
});
